// frozen_string_literal: true

export class VehicleCardUpdater {
  constructor(application) {
    this.application = application
  }

  updateVehicleCards(vehicles) {
    // Garantir ordenação: online primeiro, depois offline
    const sortedVehicles = this.sortVehiclesByCommStatus(vehicles)
    
    // Reorganizar cards na DOM
    this.reorderVehicleCardsInDOM(sortedVehicles)
    
    sortedVehicles.forEach(vehicle => {
      const vehicleCard = document.querySelector(`[data-vehicle-id="${vehicle.id}"]`)
      
      if (!vehicleCard) {
        return
      }

      this.updateVehicleMetrics(vehicleCard, vehicle)
      this.updateVehicleStatus(vehicleCard, vehicle)
      this.updateLastCommunication(vehicleCard, vehicle)
    })
  }

  sortVehiclesByCommStatus(vehicles) {
    return vehicles.sort((a, b) => {
      // 1. Status de comunicação (online primeiro)
      const aCommOk = (a.comm_status === 'ok' || a.status === 'online') ? 0 : 1
      const bCommOk = (b.comm_status === 'ok' || b.status === 'online') ? 0 : 1
      
      if (aCommOk !== bCommOk) {
        return aCommOk - bCommOk
      }
      
      // 2. Última comunicação
      const aLastUpdate = a.last_update_minutes || 999999
      const bLastUpdate = b.last_update_minutes || 999999
      
      if (aLastUpdate !== bLastUpdate) {
        return aLastUpdate - bLastUpdate
      }
      
      // 3. Nome da placa
      const aPlate = a.plate || 'zzz'
      const bPlate = b.plate || 'zzz'
      return aPlate.localeCompare(bPlate)
    })
  }

  reorderVehicleCardsInDOM(sortedVehicles) {
    const vehiclesContainer = document.querySelector('.vehicles-list')
    if (!vehiclesContainer) return
    
    const existingCards = new Map()
    vehiclesContainer.querySelectorAll('[data-vehicle-id]').forEach(card => {
      const vehicleId = card.getAttribute('data-vehicle-id')
      existingCards.set(vehicleId, card)
    })
    
    sortedVehicles.forEach((vehicle, index) => {
      const card = existingCards.get(vehicle.id)
      if (card) {
        vehiclesContainer.appendChild(card)
      }
    })
  }

  updateVehicleMetrics(vehicleCard, vehicle) {
    const metrics = vehicleCard.querySelectorAll('.metric')
    
    metrics.forEach((metric, index) => {
      const text = metric.textContent.trim()
      const label = metric.querySelector('.text-xs')?.textContent?.trim() || ''
      this.updateSpecificMetric(metric, vehicle, label, text, index)
    })
    
    // Backup com seletores específicos
    this.updateMetricsWithSpecificSelectors(vehicleCard, vehicle)
  }

  updateSpecificMetric(metric, vehicle, label, text, index) {
    const valueElement = metric.querySelector('.text-base')
    if (!valueElement) return
    
    const currentValue = valueElement.textContent.trim()
    
    // Velocidade
    if (label === 'KM/h' || text.includes('KM/h')) {
      if (vehicle.has_speed && vehicle.speed !== undefined) {
        const newSpeed = parseInt(vehicle.speed) || 0
        
        valueElement.textContent = newSpeed
        valueElement.innerText = newSpeed
        valueElement.innerHTML = newSpeed
        
        return
      }
    }
    
    // RPM
    if (label === 'RPM') {
      if (vehicle.has_rpm !== undefined && vehicle.rpm !== undefined) {
        const newRpm = Math.round(vehicle.rpm || 0)
        valueElement.textContent = newRpm
        return
      }
    }
    
    // Temperatura
    if (label === 'Temp' || text.includes('°C')) {
      if (vehicle.has_temperature !== undefined && vehicle.temperature !== undefined) {
        const newTemp = `${Math.round(vehicle.temperature || 0)}°C`
        valueElement.textContent = newTemp
        return
      }
    }
    
    // Satélites GPS
    if (label === 'Satélites' || text.includes('Satélites')) {
      if (vehicle.gps_satellites_active !== undefined && vehicle.gps_satellites_total !== undefined) {
        const newSatelliteText = `${vehicle.gps_satellites_active}/${vehicle.gps_satellites_total}`
        valueElement.textContent = newSatelliteText
        return
      }
    }
    
    // Voltagem
    if (label === 'Voltagem' || text.includes('Voltagem') || (text.includes('V') && !text.includes('SVG'))) {
      if (vehicle.has_voltage !== undefined && vehicle.voltage !== undefined) {
        const newVoltage = `${parseFloat(vehicle.voltage).toFixed(1)}V`
        valueElement.textContent = newVoltage
        return
      }
    }
    
    // Bateria Backup
    if (label === 'Backup' || text.includes('Backup')) {
      if (vehicle.has_backup_battery !== undefined && vehicle.backup_battery !== undefined) {
        const batteryBar = metric.querySelector('.h-full')
        valueElement.textContent = `${vehicle.backup_battery}%`
        
        if (batteryBar) {
          batteryBar.style.width = `${vehicle.backup_battery}%`
          const bgColor = vehicle.backup_battery > 60 ? 'linear-gradient(to right, #34d399, #10b981)' : 
                         vehicle.backup_battery > 30 ? 'linear-gradient(to right, #fbbf24, #f59e0b)' : 
                         'linear-gradient(to right, #f87171, #ef4444)'
          batteryBar.style.background = bgColor
        }
        return
      }
    }
    
    // Odômetro
    if ((label.includes('KM') || label.includes('Milhas')) && !label.includes('KM/h')) {
      if (vehicle.has_odometer !== undefined && vehicle.odometer !== undefined) {
        const formattedOdometer = this.formatOdometerCompact(vehicle.odometer)
        valueElement.textContent = formattedOdometer
        return
      }
    }
    
    // Horímetro
    if (label === 'Horímetro') {
      if (vehicle.has_horimeter !== undefined && vehicle.horimeter !== undefined) {
        const formattedHorimeter = this.formatHorimeter(vehicle.horimeter)
        valueElement.textContent = formattedHorimeter
        return
      }
    }
  }

  updateMetricsWithSpecificSelectors(vehicleCard, vehicle) {
    // Velocidade com seletores específicos
    if (vehicle.has_speed && vehicle.speed !== undefined) {
      const speedSelectors = [
        '.metric:has(.text-blue-600) .text-base',
        '.metric .text-blue-600 + .text-base', 
        '.metric .text-blue-600 ~ .text-base'
      ]
      
      let speedUpdated = false
      
      for (const selector of speedSelectors) {
        try {
          const speedElement = vehicleCard.querySelector(selector)
          if (speedElement) {
            const newSpeed = parseInt(vehicle.speed) || 0
            
            speedElement.textContent = newSpeed
            speedElement.innerText = newSpeed
            speedElement.innerHTML = newSpeed
            
            speedUpdated = true
            break
          }
        } catch (e) {
          // Error handling for selectors
        }
      }
      
      if (!speedUpdated) {
        // Último recurso
        const allMetrics = vehicleCard.querySelectorAll('.metric')
        allMetrics.forEach((metric, index) => {
          if (metric.textContent.includes('KM/h')) {
            const speedElement = metric.querySelector('.text-base')
            if (speedElement) {
              const newSpeed = parseInt(vehicle.speed) || 0
              speedElement.textContent = newSpeed
            }
          }
        })
      }
    }
    
    // RPM com seletores específicos
    if (vehicle.has_rpm !== undefined && vehicle.rpm !== undefined) {
      const rpmSelectors = [
        '.metric:has(.text-purple-600) .text-base',
        '.metric .text-purple-600 + .text-base',
        '.metric .text-purple-600 ~ .text-base'
      ]
      
      for (const selector of rpmSelectors) {
        const rpmElement = vehicleCard.querySelector(selector)
        if (rpmElement) {
          const newRpm = Math.round(vehicle.rpm || 0)
          rpmElement.textContent = newRpm
          break
        }
      }
    }
    
    // Voltagem com seletores específicos
    if (vehicle.has_voltage !== undefined && vehicle.voltage !== undefined) {
      const voltageSelectors = [
        '.metric:has(.text-yellow-600) .text-base',
        '.metric .text-yellow-600 + .text-base',
        '.metric .text-yellow-600 ~ .text-base'
      ]
      
      for (const selector of voltageSelectors) {
        const voltageElement = vehicleCard.querySelector(selector)
        if (voltageElement) {
          const newVoltage = `${parseFloat(vehicle.voltage).toFixed(1)}V`
          voltageElement.textContent = newVoltage
          break
        }
      }
    }
  }

  updateVehicleStatus(vehicleCard, vehicle) {
    const statusBadge = vehicleCard.querySelector('.px-2.py-1')
    if (statusBadge && vehicle.status) {
      const statusClasses = this.getStatusBadgeClasses(vehicle.status)
      statusBadge.className = `px-2 py-1 text-xs font-medium rounded-full whitespace-nowrap ${statusClasses.bg}`
      statusBadge.textContent = statusClasses.text
    }

    if (vehicle.vehicle_state) {
      vehicleCard.setAttribute('data-vehicle-state', vehicle.vehicle_state)
    }
    if (vehicle.comm_status) {
      vehicleCard.setAttribute('data-comm-status', vehicle.comm_status)
    }
  }

  updateLastCommunication(vehicleCard, vehicle) {
    const lastCommElement = vehicleCard.querySelector('.vehicle-last-comm')
    if (!lastCommElement || !vehicle.last_communication) return

    lastCommElement.textContent = vehicle.last_communication

    const vehicleController = this.application.getControllerForElementAndIdentifier(vehicleCard, 'vehicle-timer')

    // last_update_minutes é nil quando o veículo nunca comunicou (nenhum
    // gps_datetime) -- não confundir com 0 (comunicou há menos de 1 minuto).
    if (vehicle.last_update_minutes == null) {
      if (vehicleController) vehicleController.stopTracking()
      return
    }

    lastCommElement.dataset.lastUpdateMinutes = vehicle.last_update_minutes
    if (vehicleController) {
      vehicleController.updateTrackerCommunication(vehicle.last_update_minutes)
    }
  }

  // Métodos auxiliares
  formatOdometerCompact(odometer) {
    if (!odometer) return '0'
    const km = odometer / 1000
    if (km >= 1000) {
      return `${(km / 1000).toFixed(1)}M`
    } else if (km >= 1) {
      return `${km.toFixed(1)}K`
    }
    return km.toString()
  }

  formatHorimeter(horimeter) {
    if (!horimeter) return '0h'
    const hours = Math.floor(horimeter / 3600)
    return `${hours}h`
  }

  getStatusBadgeClasses(status) {
    switch (status) {
      case 'online':
        return { bg: 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100', text: 'Online' }
      case 'offline':
        return { bg: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100', text: 'Offline' }
      default:
        return { bg: 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100', text: 'Desconhecido' }
    }
  }
}